module.exports = __webpack_public_path__ + "media/media/advantages/international_team-039d44910d18b91b0fe4d72052127e73.png";